/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Modal } from "@material-ui/core";
import clsx from "clsx";
import RedirectToOnboardingDesktopImage from "components/RevampFeedDetails/assets/RedirectToOnboardingDesktopImage";
import RedirectToOnboardingIcon from "components/RevampFeedDetails/assets/RedirectToOnboardingIcon";
import React, { useEffect, useState } from "react";
import { useWindowResize } from "utils/hooks";

const RedirectToOnboarding = ({ open, applyLink }) => {
	const [progress, setProgress] = useState(0);
	const [isMobileView] = useWindowResize();

	useEffect(() => {
		const intervalId = setInterval(() => {
			setProgress((prev) => {
				if (prev === 100) {
					clearInterval(intervalId);
					return 100;
				}
				return prev + 1;
			});
		}, 35);
		return () => {
			clearInterval(intervalId);
		};
	}, []);
	if (isMobileView)
		return (
			<Modal open={open}>
				<div
					className={clsx(
						"fixed bottom-0 left-0 z-40 w-full space-y-[16px] rounded-t-[16px] bg-white p-[16px]",
						{
							hidden: !open,
						}
					)}
				>
					<div>
						<RedirectToOnboardingIcon />
					</div>
					<div className="space-y-[8px]">
						<p className="leading[28px] m-0 text-xl font-bold text-[#190A28]">
							HR wants you to update your profile before you apply
						</p>
						<p className="m-0 text-sm leading-[20px] text-[#8C8594]">
							Increase your chances of getting hired with your latest
							profile
						</p>
					</div>
					<div
						className="relative w-full cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[8px] text-center font-semibold text-white opacity-90"
						onClick={() => window.open(applyLink, "_self")}
					>
						Get started
						<span
							className="absolute left-0 top-0 -z-20 h-[39px] bg-[#005F3E]"
							style={{
								width: `${progress}%`,
							}}
						/>
					</div>
				</div>
			</Modal>
		);
	return (
		<Modal open={open}>
			<div className="absolute left-[50%] top-[50%] z-20 w-[688px] translate-x-[-50%] translate-y-[-50%] overflow-hidden rounded-lg bg-white">
				<div>
					<RedirectToOnboardingDesktopImage />
				</div>
				<div className="flex flex-col items-center justify-center p-[32px] text-center">
					<div className="space-y-[8px]">
						<p className="leading[28px] m-0 mx-auto w-[400px] text-xl font-bold text-[#190A28]">
							HR wants you to update your profile before you apply
						</p>
						<p className="m-0 text-md leading-[20px] text-[#190A28]">
							Increase your chances of getting hired with your latest
							profile
						</p>
					</div>
					<div
						className="relative mt-[24px] w-[376px] cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[8px] text-center font-semibold text-white opacity-90"
						onClick={() => window.open(applyLink, "_self")}
					>
						Get started
						<span
							className="absolute left-0 top-0 -z-20 h-[42px] rounded bg-[#005F3E]"
							style={{
								width: `${progress}%`,
							}}
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default RedirectToOnboarding;
